import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/uploads";

export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return jeepRallyApi.post(baseUrl, formData);
};
